import React, { useContext } from 'react';
const UserDetails = /*#__PURE__*/React.createContext(undefined);
export function useUserDetails() {
  return useContext(UserDetails);
}
export default UserDetails;